var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"DOT活动","name":"1"}},[_c('event-program',{ref:"eventProgram"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }